export default {
    // 中
    zhCN: {
        newly_built: '新建',
        fieldSupportNumber: '现场支持单号',
        informationSlipNumber: '问询单号',
        approvalStatus: '审批状态',
        state: '状态',
        selectApplicationDate: '选择申请日期',
        toBeProcessed: '待处理',
        processed: '已处理',
        initiated: '已发起',
        applicationDepartment: '申请部门',
        applicant: '申请人',
        reasonApplication: '申请原因',
        applicationTime: '申请时间',
        view: {
            application_department: '申请部门',
            application_person: '申请人',
            responsible_person: '负责人',
            associated_enquiry_number: '关联问询单号',
            reason_application: '申请原因',
            description: '说明(内部申请签字单)',
            file_name: '文件名',
            size: '大小(MB)',
            uploader: '上传人',
            upload_time: '上传时间',
            view: '查看',
            download: '下载',
            support_department: '支持部门',
            technical_personnel: '技术人员',
            contact_information: '联系方式',
            field_support_information: '现场支持信息',
            remarks: '备注',
            apply: '审批',
            application_information: '申请信息',
            field_support_personnel: '现场支持人员',
            approval_record: '审批记录',
            submit_an_application: '提交申请',
            refuse: '拒绝',
            agree: '同意',
            apply_for: '申请',
            field_support: '现场支持',
            reason_for_rejection: '拒绝原因',
        },
        dialog: {
            on_site_application_details: '现场申请详情',
            on_site_application: '现场申请',
            reason_for_rejection: '拒绝原因',
            field_support_application: '现场支持申请',
            technical_personnel: '技术人员',
            contact_information: '联系方式',
            field_support_time: '现场支持时间',
            note_information: '备注信息',
        },
    },
    // 英
    enUS: {
        newly_built: 'Add',
        fieldSupportNumber: 'Field support number',
        informationSlipNumber: 'Technical inquiry #',
        approvalStatus: 'Approval status',
        state: 'State',
        selectApplicationDate: 'Select the application date',
        toBeProcessed: 'To be processed',
        processed: 'Processed',
        initiated: 'Initiated',
        applicationDepartment: 'Application department',
        applicant: 'Applicant',
        reasonApplication: 'Reason for application',
        applicationTime: 'Application time',
        view: {
            application_department: 'Application department',
            responsible_person: 'Responsible person',
            application_person: 'Application person',
            associated_enquiry_number: 'Associated enquiry number',
            reason_application: 'Reason for application',
            description: 'Description(Internal application signature sheet)',
            file_name: 'File name',
            size: 'Size(MB)',
            uploader: 'Uploader',
            upload_time: 'Upload time',
            view: 'Check',
            download: 'Download',
            support_department: 'Support department',
            technical_personnel: 'Technical personnel',
            contact_information: 'Contact information',
            field_support_information: 'Field support information',
            remarks: 'Remarks',
            apply: 'Apply',
            application_information: 'Application information',
            field_support_personnel: 'On-site support personnel',
            approval_record: 'Approval history',
            submit_an_application: 'Submit an application',
            refuse: 'Refuse',
            agree: 'Agree',
            apply_for: 'Apply for',
            field_support: 'Field support',
            reason_for_rejection: 'Reason for rejection',
        },
        dialog: {
            on_site_application_details: 'On-site application details',
            on_site_application: 'On-site application',
            reason_for_rejection: 'Reason for rejection',
            field_support_application: 'apply for on-site technical support',
            technical_personnel: 'Technical personnel',
            contact_information: 'Contact Telephone',
            field_support_time: 'On-site support time',
            note_information: 'Note information',
        },
    },
    // 德
    deDE: {
        newly_built: 'Hinzugefügt',
        fieldSupportNumber: 'Feldunterstützungsnummer',
        informationSlipNumber: 'Informationszettelnummer',
        approvalStatus: 'Genehmigungsstatus',
        state: 'Zustand',
        selectApplicationDate: 'Wählen Sie das Anwendungsdatum aus',
        toBeProcessed: 'Zu bearbeiten',
        processed: 'Verarbeitet',
        initiated: 'Initiiert',
        applicationDepartment: 'Antragsabteilung',
        applicant: 'Antragsteller',
        reasonApplication: 'Grund für den Antrag',
        applicationTime: 'Antragszeit',
        view: {
            application_department: 'Antragsabteilung',
            responsible_person: 'Verantwortliche Person',
            application_person: 'Antragsteller',
            associated_enquiry_number: 'Zugehörige Anfragenummer',
            reason_application: 'Grund für den Antrag',
            description: 'Beschreibung (Interner Antragssignaturbogen)',
            file_name: 'Dateiname',
            size: 'Größe (MB)',
            uploader: 'Uploader',
            upload_time: 'Upload-Zeit',
            view: 'Prüfen',
            download: 'Herunterladen',
            support_department: 'Unterstützungsabteilung',
            technical_personnel: 'Technisches Personal',
            contact_information: 'Kontaktinformationen',
            field_support_information: 'Informationen zur Feldunterstützung',
            remarks: 'Bemerkungen',
            apply: 'Bewerben',
            application_information: 'Anwendungsinformationen',
            field_support_personnel: 'Vor-Ort-Supportpersonal',
            approval_record: 'Genehmigungsverlauf',
            submit_an_application: 'Ein Antrag stellen',
            refuse: 'Ablehnen',
            agree: 'Zustimmen ',
            apply_for: 'Antrag auf ',
            field_support: 'Feldunterstützung',
            reason_for_rejection: 'Grund für die Ablehnung',
        },
        dialog: {
            on_site_application_details: 'Details zur Vor-Ort-Anwendung',
            on_site_application: 'Vor-Ort-Anwendung',
            reason_for_rejection: 'Grund für die Ablehnung',
            field_support_application: 'Antrag auf Feldunterstützung',
            technical_personnel: 'Technisches Personal',
            contact_information: 'Kontakt Telefon',
            field_support_time: 'Zeitpunkt der Vor-Ort-Unterstützung',
            note_information: 'Notizinformationen',
        },
    },
    // 法
    frFR: {
        newly_built: 'Ajouter',
        fieldSupportNumber: 'Numéro de support sur le terrain',
        informationSlipNumber: 'Demande Technique #',
        approvalStatus: 'Statut d\'approbation',
        state: 'Statut',
        selectApplicationDate: 'Sélectionnez la date de demande',
        toBeProcessed: 'À traiter',
        processed: 'Traité',
        initiated: 'initié',
        applicationDepartment: 'Demandeur',
        applicant: 'Demandeur',
        reasonApplication: 'Justification de la demande',
        applicationTime: 'Heure de demande',
        view: {
            application_department: 'Service demandeur',
            responsible_person: 'Personne responsable',
            application_person: 'postulant',
            associated_enquiry_number: 'Numéro d\'enquête associé',
            reason_application: 'Raison de la demande',
            description: 'Description(Feuille de signature de demande interne)',
            file_name: 'Nom du fichier',
            size: 'Taille (Mo)',
            uploader: 'Téléchargé par',
            upload_time: 'Temps de Téléchargement ',
            view: 'Voir',
            download: 'Télécharger',
            support_department: 'Service de support',
            technical_personnel: 'Personnel technique',
            contact_information: 'Contact téléphonique',
            field_support_information: 'Informations de support sur le terrain',
            remarks: 'Remarque',
            apply: 'Soumettre',
            application_information: 'Informations de demande',
            field_support_personnel: 'Technicien sur site',
            approval_record: 'Historique d\'approbation',
            submit_an_application: 'Soumettre une demande',
            refuse: 'Refuser',
            agree: 'Accepter',
            apply_for: 'Demander',
            field_support: 'Support sur le terrain',
            reason_for_rejection: 'Raison du rejet',
        },
        dialog: {
            on_site_application_details: 'Demander une assistance technique sur site',
            on_site_application: 'Demande sur place',
            reason_for_rejection: 'Raison du rejet',
            field_support_application: 'Demande de support sur le terrain',
            technical_personnel: 'Personnel technique',
            contact_information: 'Contact téléphonique',
            field_support_time: 'Temps d\'assistance sur site',
            note_information: 'Remarque',
        },
    },
    // 意大利
    itIT: {
        newly_built: 'Aggiungi',
        fieldSupportNumber: 'Numero di supporto sul campo',
        informationSlipNumber: 'Numero del modulo informazioni',
        approvalStatus: 'Stato di approvazione',
        state: 'Stato',
        selectApplicationDate: 'Seleziona la data di richiesta',
        toBeProcessed: 'Da elaborare',
        processed: 'Elaborato',
        initiated: 'Iniziato',
        applicationDepartment: 'Dipartimento di applicazione',
        applicant: 'Richiedente',
        reasonApplication: 'Motivo della richiesta',
        applicationTime: 'Tempo di applicazione',
        view: {
            application_department: 'Dipartimento di applicazione',
            responsible_person: 'Persona responsabile',
            application_person: 'Persona che fa la domanda',
            associated_enquiry_number: 'Numero di indagine associato',
            reason_application: 'Motivo della richiesta',
            description: 'Descrizione (foglio firma interna della domanda)',
            file_name: 'Nome del file',
            size: 'Dimensione (MB)',
            uploader: 'Caricatore',
            upload_time: 'Tempo di caricamento',
            view: 'Verifica',
            download: 'Scarica',
            support_department: 'Dipartimento di supporto',
            technical_personnel: 'Personale tecnico',
            contact_information: 'Informazioni di contatto',
            field_support_information: 'Informazioni sul supporto sul campo',
            remarks: 'Osservazioni',
            apply: 'Applicare',
            application_information: 'Informazioni sulla richiesta',
            field_support_personnel: 'Personale di supporto sul sito',
            approval_record: 'Storia dell\'approvazione',
            submit_an_application: 'Presentare una domanda',
            refuse: 'Rifiutare',
            agree: 'Convenire',
            apply_for: 'Richiedere',
            field_support: 'Supporto sul campo',
            reason_for_rejection: 'Motivo del rifiuto',
        },
        dialog: {
            on_site_application_details: 'Dettagli della richiesta sul sito',
            on_site_application: 'Richiesta sul sito',
            reason_for_rejection: 'Motivo del rifiuto',
            field_support_application: 'Domanda di supporto sul campo',
            technical_personnel: 'Personale tecnico',
            contact_information: 'Telefono di contatto',
            field_support_time: 'Tempo di supporto sul campo',
            note_information: 'Informazioni sulla nota',
        },
    },
    // 荷兰
    nlNL: {
        newly_built: 'Toevoegen',
        fieldSupportNumber: 'Veldondersteuningsnummer',
        informationSlipNumber: 'Informatie slipnummer',
        approvalStatus: 'Goedkeuringsstatus',
        state: 'Staat',
        selectApplicationDate: 'Selecteer de aanvraagdatum',
        toBeProcessed: 'Te verwerken',
        processed: 'Verwerkt',
        initiated: 'Geïnitieerd',
        applicationDepartment: 'Afdeling aanvraag',
        applicant: 'Aanvrager',
        reasonApplication: 'Reden voor aanvraag',
        applicationTime: 'Aanvraagtijd',
        view: {
            application_department: 'Afdeling aanvraag',
            responsible_person: 'Verantwoordelijke persoon',
            application_person: 'Aanvraagpersoon',
            associated_enquiry_number: 'Bijbehorend vraagnummer',
            reason_application: 'Reden voor aanvraag',
            description: 'Beschrijving(Interne aanvraagondertekening)',
            file_name: 'Bestandsnaam',
            size: 'Grootte(MB)',
            uploader: 'Uploader',
            upload_time: 'Uploadtijd',
            view: 'Check',
            download: 'download',
            support_department: 'Ondersteuningsafdeling',
            technical_personnel: 'Technisch personeel',
            contact_information: 'Contactgegevens',
            field_support_information: 'Veldondersteuningsinformatie',
            remarks: 'Opmerkingen',
            apply: 'Solliciteren',
            application_information: 'Aanvraaginformatie',
            field_support_personnel: 'Ondersteuningspersoneel ter plaatse',
            approval_record: 'Goedkeuringsgeschiedenis',
            submit_an_application: 'Dien een aanvraag in',
            refuse: 'Weigeren',
            agree: 'Overeenkomen',
            apply_for: 'Toepassen voor',
            field_support: 'Veldondersteuning',
            reason_for_rejection: 'Reden van afwijzing',
        },
        dialog: {
            on_site_application_details: 'Details van de aanvraag op locatie',
            on_site_application: 'Aanvraag op locatie',
            reason_for_rejection: 'Reden van afwijzing',
            field_support_application: 'Veldondersteuningsaanvraag',
            technical_personnel: 'Technisch personeel',
            contact_information: 'Contact telefoon',
            field_support_time: 'Tijd van ondersteuning ter plaatse',
            note_information: 'Notitie informatie',
        },
    },
    // 越南
    viVN: {
        newly_built: 'Mới tạo',
        fieldSupportNumber: 'Số hỗ trợ trường hợp',
        informationSlipNumber: 'Yêu cầu kỹ thuật #',
        approvalStatus: 'Trạng thái phê duyệt',
        state: 'Trạng thái',
        selectApplicationDate: 'Chọn ngày ứng dụng',
        toBeProcessed: 'Đang chờ xử lý',
        processed: 'Đã xử lý',
        initiated: 'Đã khởi tạo',
        applicationDepartment: 'Người đăng ký',
        applicant: 'Người đăng ký',
        reasonApplication: 'Lý do đăng ký',
        applicationTime: 'Thời gian đăng ký',
        view: {
            application_department: 'Bộ phận ứng dụng',
            application_person: 'Người ứng dụng',
            responsible_person: 'Người chịu trách nhiệm',
            associated_enquiry_number: 'Số yêu cầu liên quan',
            reason_application: 'Lý do ứng dụng',
            description: 'Mô tả (Biểu mẫu đăng ký nội bộ)',
            file_name: 'Tên tập tin',
            size: 'Kích thước (MB)',
            uploader: 'Người tải lên',
            upload_time: 'Thời gian tải lên',
            view: 'Xem',
            download: 'Tải về',
            support_department: 'Bộ phận hỗ trợ',
            technical_personnel: 'Nhân viên kỹ thuật',
            contact_information: 'Thông tin liên hệ',
            field_support_information: 'Thông tin hỗ trợ trường hợp',
            remarks: 'Ghi chú',
            apply: 'Áp dụng',
            application_information: 'Thông tin ứng dụng',
            field_support_personnel: 'Nhân viên hỗ trợ tại chổ',
            approval_record: 'Lịch sử phê duyệt',
            submit_an_application: 'Gửi một đơn đăng ký',
            refuse: 'Từ chối',
            agree: 'Đồng ý',
            apply_for: 'Yêu cầu',
            field_support: 'Hỗ trợ trường hợp',
            reason_for_rejection: 'Lý do từ chối',
        },
        dialog: {
            on_site_application_details: 'Chi tiết đơn đăng ký trường hợp',
            on_site_application: 'Đơn đăng ký trường hợp',
            reason_for_rejection: 'Lý do từ chối',
            field_support_application: 'Đăng ký cho trường hợp hỗ trợ kỹ thuật tại chổ',
            technical_personnel: 'Nhân viên kỹ thuật',
            contact_information: 'Số điện thoại liên lạc',
            field_support_time: 'Thời gian hỗ trợ tại chổ',
            note_information: 'Thông tin ghi chú',
        },
    },
    // 西班牙
    esES: {
        newly_built: 'Nuevo',
        fieldSupportNumber: 'Número de soporte en el sitio',
        informationSlipNumber: 'Número de consulta',
        approvalStatus: 'Estado de aprobación',
        state: 'Estado',
        selectApplicationDate: 'Seleccione la fecha de solicitud',
        toBeProcessed: 'Pendiente',
        processed: 'Procesado',
        initiated: 'Iniciado',
        applicationDepartment: 'Departamento solicitante',
        applicant: 'Solicitante',
        reasonApplication: 'Motivo de la solicitud',
        applicationTime: 'Fecha de solicitud',
        view: {
            application_department: 'Departamento solicitante',
            application_person: 'Solicitante',
            responsible_person: 'Responsable',
            associated_enquiry_number: 'Número de consulta relacionada',
            reason_application: 'Motivo de la solicitud',
            description: 'Descripción (formulario de firma de solicitud interna)',
            file_name: 'Nombre del archivo',
            size: 'Tamaño (MB)',
            uploader: 'Persona que subió',
            upload_time: 'Fecha de carga',
            view: 'Ver',
            download: 'Descargar',
            support_department: 'Departamento de soporte',
            technical_personnel: 'Personal técnico',
            contact_information: 'Información de contacto',
            field_support_information: 'Información de soporte en el sitio',
            remarks: 'Observaciones',
            apply: 'Aprobación',
            application_information: 'Información de solicitud',
            field_support_personnel: 'Personal de soporte en el sitio',
            approval_record: 'Registro de aprobación',
            submit_an_application: 'Enviar solicitud',
            refuse: 'Rechazar',
            agree: 'Aceptar',
            apply_for: 'Solicitud',
            field_support: 'Soporte en terreno',
            reason_for_rejection: 'Motivo de rechazo',
        },
        dialog: {
            on_site_application_details: 'Detalles de la solicitud en el sitio',
            on_site_application: 'Solicitud en el sitio',
            reason_for_rejection: 'Motivo de rechazo',
            field_support_application: 'Solicitud de soporte en el sitio',
            technical_personnel: 'Personal técnico',
            contact_information: 'Información de contacto',
            field_support_time: 'Fecha de soporte en el sitio',
            note_information: 'Información adicional',
        },
    },
    // 葡萄牙
    ptBR: {
        newly_built: 'Nova construção',
        fieldSupportNumber: 'Número de Suporte de Campo',
        informationSlipNumber: 'Número de Consulta',
        approvalStatus: 'Status de Aprovação',
        state: 'Estado',
        selectApplicationDate: 'Selecionar Data de Aplicação',
        toBeProcessed: 'A Ser Processado',
        processed: 'Processado',
        initiated: 'Iniciado',
        applicationDepartment: 'Departamento de Aplicação',
        applicant: 'Solicitante',
        reasonApplication: 'Motivo da Aplicação',
        applicationTime: 'Tempo de Aplicação',
        view: {
            application_department: 'Departamento de Aplicação',
            application_person: 'Solicitante',
            responsible_person: 'Pessoa Responsável',
            associated_enquiry_number: 'Número de Consulta Associado',
            reason_application: 'Motivo da Aplicação',
            description: 'Descrição (Formulário de Assinatura Interna de Aplicação)',
            file_name: 'Nome do Arquivo',
            size: 'Tamanho (MB)',
            uploader: 'Uploader',
            upload_time: 'Tempo de Upload',
            view: 'Visualizar',
            download: 'Download',
            support_department: 'Departamento de Suporte',
            technical_personnel: 'Pessoal Técnico',
            contact_information: 'Informações de Contato',
            field_support_information: 'Informações de Suporte de Campo',
            remarks: 'Observações',
            apply: 'Aplicar',
            application_information: 'Informações da Aplicação',
            field_support_personnel: 'Pessoal de Suporte de Campo',
            approval_record: 'Registro de Aprovação',
            submit_an_application: 'Enviar uma Aplicação',
            refuse: 'Recusar',
            agree: 'Concordar',
            apply_for: 'Aplicar',
            field_support: 'Suporte de Campo',
            reason_for_rejection: 'Motivo da Rejeição',
        },
        dialog: {
            on_site_application_details: 'Detalhes da Aplicação no Local',
            on_site_application: 'Aplicação no Local',
            reason_for_rejection: 'Motivo da Rejeição',
            field_support_application: 'Aplicação de Suporte de Campo',
            technical_personnel: 'Pessoal Técnico',
            contact_information: 'Informações de Contato',
            field_support_time: 'Tempo de Suporte de Campo',
            note_information: 'Informações da Nota',
        },
    },
    // 波兰
    plPL: {
        newly_built: 'Nowy',
        fieldSupportNumber: 'Numer wsparcia lokalnego',
        informationSlipNumber: 'Numer zapytania',
        approvalStatus: 'Status zatwierdzenia',
        state: 'Status',
        selectApplicationDate: 'Wybierz datę złożenia wniosku',
        toBeProcessed: 'Oczekuje ',
        processed: 'W trakcie',
        initiated: 'Rozpoczęte',
        applicationDepartment: 'Dział aplikujący',
        applicant: 'Aplikant',
        reasonApplication: 'Powód wniosku',
        applicationTime: 'Czas złożenia wniosku',
        view: {
            application_department: 'Dział aplikujący',
            application_person: 'Aplikant',
            responsible_person: 'Osoba odpowiedzialna',
            associated_enquiry_number: 'Powiązany numer zapytania',
            reason_application: 'Powód wniosku',
            description: 'Wyjaśnienie (arkusz podpisów wniosków wewnętrznych)',
            file_name: 'Nazwa pliku',
            size: 'Rozmiar (MB)',
            uploader: 'Przesyłający',
            upload_time: 'Czas przesłania',
            view: 'Sprawdź',
            download: 'Ściągnij',
            support_department: 'Odzsiał wspierający',
            technical_personnel: 'Personel techniczny',
            contact_information: 'Informacje kontaktowe',
            field_support_information: 'Informacje o wsparciu terenowym',
            remarks: 'Uwagi',
            apply: 'Zatwierdź',
            application_information: 'Informacje dot. Wniosku',
            field_support_personnel: 'Personel techniczny na miejscu',
            approval_record: 'Historia zatwierdzeń',
            submit_an_application: 'Przekaż wniosek',
            refuse: 'Odmowa',
            agree: 'Zgoda',
            apply_for: 'Wnioskować o',
            field_support: 'Wsparcie terenowe',
            reason_for_rejection: 'Powód odmowy',
        },
        dialog: {
            on_site_application_details: 'Informacje o wniosku lokalnym',
            on_site_application: 'Wniosek lokalny',
            reason_for_rejection: 'Powód odmowy',
            field_support_application: 'Wnioskój o wsparcie techniczne na miejscu',
            technical_personnel: 'Personel techniczny',
            contact_information: 'Kontakt',
            field_support_time: 'Data wsparcia',
            note_information: 'Uwagi',
        },
    },

    // 土耳其
    trTR: {
        newly_built: 'Ekle',
        fieldSupportNumber: 'Alan destek numarası',
        informationSlipNumber: 'Teknik  sorgulama',
        approvalStatus: 'onaylama durumu',
        state: 'Durum',
        selectApplicationDate: 'Uygulama tarihini seçin',
        toBeProcessed: 'İşlenecek',
        processed: 'İşlenmiş',
        initiated: 'Başlatılmış',
        applicationDepartment: 'Müracat departmanı',
        applicant: 'Müracat eden',
        reasonApplication: 'Müracat etme sebebi',
        applicationTime: 'Müracat zamanı',
        view: {
            application_department: 'Müracat  departmanı',
            application_person: 'Sorumlu kişi',
            responsible_person: 'Uygulama kişi',
            associated_enquiry_number: 'Ortak sorgulama numarası',
            reason_application: 'Uygulama sebebi',
            description: 'Açıklama(Dahili uygulama imzalama sayfası)',
            file_name: 'Dosya adı',
            size: 'Ölçü( MB)',
            uploader: 'Yükleyici',
            upload_time: 'Yükleme vakti',
            view: 'Kontrol',
            download: 'İndir',
            support_department: 'Destek departmanı',
            technical_personnel: 'Tehnik personel',
            contact_information: 'Kontakt bilgisi',
            field_support_information: 'Alan desteği bilgileri',
            remarks: 'Yorumlar',
            apply: 'Uygula',
            application_information: 'Uygulama bilgisi',
            field_support_personnel: 'İnternet destek personeli',
            approval_record: 'Onay geçmişi',
            submit_an_application: 'Müracat gönder',
            refuse: 'Geri çevirme',
            agree: 'Kabul etme',
            apply_for: 'Müracat etme',
            field_support: 'Alan desteği',
            reason_for_rejection: 'Geri çevirme nedeni',
        },
        dialog: {
            on_site_application_details: 'Yerde uygulama detayları',
            on_site_application: 'İnternet üstünden müracat etme',
            reason_for_rejection: 'Geri çevirme nedeni',
            field_support_application: 'İnternet  üstünden teknik destek talebi',
            technical_personnel: 'Tehnik personel',
            contact_information: 'Kontakt Telefonu',
            field_support_time: 'İnternet üstünden teknik destek zamanı',
            note_information: 'Not bilgisi',
        },
    },
    // 捷克语
    csCZ: {
        newly_built: 'Přidat',
        fieldSupportNumber: 'Číslo podpory',
        informationSlipNumber: 'Technický dotaz č.',
        approvalStatus: 'Stav schválení',
        state: 'Stav',
        selectApplicationDate: 'Vyberte datum aplikace',
        toBeProcessed: 'Ke zpracování',
        processed: 'Zpracováno',
        initiated: 'Zahájeno',
        applicationDepartment: 'Oddělení žádostí',
        applicant: 'Žadatel',
        reasonApplication: 'Důvod žádosti',
        applicationTime: 'Čas žádosti',
        view: {
            application_department: 'Oddělení žádostí',
            application_person: 'Odpovědná osoba',
            responsible_person: 'Aplikační osoba',
            associated_enquiry_number: 'Číslo souvisejícího dotazu',
            reason_application: 'Důvod aplikace',
            description: 'Popis (interní podpisový list aplikace)',
            file_name: 'Název souboru',
            size: 'Velikost (MB)',
            uploader: 'Uploader',
            upload_time: 'Čas nahrání',
            view: 'Kontrola',
            download: 'Stažení',
            support_department: 'Oddělení podpory',
            technical_personnel: 'Technický personál',
            contact_information: 'Kontaktní informace',
            field_support_information: 'Informace o podpoře v terénu',
            remarks: 'Poznámky',
            apply: 'Aplikovat',
            application_information: 'Informace o aplikaci',
            field_support_personnel: 'Personál podpory na místě',
            approval_record: 'Historie schválení',
            submit_an_application: 'Odešlete žádost',
            refuse: 'Odmítnout',
            agree: 'Souhlasit',
            apply_for: 'Žádat o',
            field_support: 'Podpora na místě',
            reason_for_rejection: 'Důvod zamítnutí',
        },
        dialog: {
            on_site_application_details: 'On-site application details',
            on_site_application: 'Žádost na místě',
            reason_for_rejection: 'Důvod zamítnutí',
            field_support_application: 'požádat o technickou podporu na místě',
            technical_personnel: 'Technický personál',
            contact_information: 'Kontaktní telefon',
            field_support_time: 'Doba podpory na místě',
            note_information: 'Informace o poznámkách',
        },
    },
    // 匈牙利语
    huHU: {
        newly_built: 'Hozzáadás',
        fieldSupportNumber: 'Helyszíni támogatás száma',
        informationSlipNumber: 'Műszaki érdeklődés sz.',
        approvalStatus: 'Jóváhagyás állapota',
        state: 'Állapot',
        selectApplicationDate: 'Válassza ki a kérvényezés dátumát',
        toBeProcessed: 'Feldolgozandó',
        processed: 'Feldolgozott',
        initiated: 'Kezdeményezett',
        applicationDepartment: 'Kérvényező részleg',
        applicant: 'Kérvényező',
        reasonApplication: 'Kérvényezés oka',
        applicationTime: 'Kérvényezés ideje',
        view: {
            application_department: 'Kérvényező részleg',
            application_person: 'Kérvényező',
            responsible_person: 'Felelős személy',
            associated_enquiry_number: 'Társított érdeklődés száma',
            reason_application: 'Kérvényezés oka',
            description: 'Leírás (belső kérvényezés aláíróív)',
            file_name: 'Fájlnév',
            size: 'Méret (MB)',
            uploader: 'Feltöltő',
            upload_time: 'Feltöltési idő',
            view: 'Ellenőrzés',
            download: 'Letöltés',
            support_department: 'Támogató részleg',
            technical_personnel: 'Műszaki személyzet',
            contact_information: 'Elérhetőségek',
            field_support_information: 'Helyszíni támogatási információ',
            remarks: 'Megjegyzések',
            apply: 'Alkalmazás',
            application_information: 'Kérvényezési információ',
            field_support_personnel: 'Helyszíni támogató személyzet',
            approval_record: 'Kérelmezési előzmények',
            submit_an_application: 'Kérelem beküldése',
            refuse: 'Elutasítás',
            agree: 'Beleegyezés',
            apply_for: 'Kérelem tárgya',
            field_support: 'Helyszíni támogatás',
            reason_for_rejection: 'Elutasítás oka',
        },
        dialog: {
            on_site_application_details: 'Helyszíni kérelem részletei',
            on_site_application: 'Helyszíni kérelem',
            reason_for_rejection: 'Elutasítás oka',
            field_support_application: 'Helyszíni műszaki támogatás kérelmezése',
            technical_personnel: 'Műszaki személyzet',
            contact_information: 'Kapcsolattartó telefonszám',
            field_support_time: 'Helyszíni támogatás időpontja',
            note_information: 'Megjegyzés adatai',
        },
    },
    // 俄罗斯语
    ruRU: {
        newly_built: 'Добавить',
        fieldSupportNumber: 'Номер поддержки на месте',
        informationSlipNumber: 'Технический запрос #',
        approvalStatus: 'Статус одобрения',
        state: 'Состояние',
        selectApplicationDate: 'Выберите дату подачи заявки',
        toBeProcessed: 'Обработано',
        processed: 'Обработано',
        initiated: 'Инициировано',
        applicationDepartment: 'Отдел заявки',
        applicant: 'Заявитель',
        reasonApplication: 'Причина заявки',
        applicationTime: 'Время подачи заявки',
        view: {
            application_department: 'Отдел заявки',
            application_person: 'Ответственное лицо',
            responsible_person: 'Заявитель',
            associated_enquiry_number: 'Связанный номер запроса',
            reason_application: 'Причина заявки',
            description: 'Описание (внутренний лист подписей заявки)',
            file_name: 'Название файла',
            size: 'Размер (МБ)',
            uploader: 'Загрузил',
            upload_time: 'Время загрузки',
            view: 'Проверка',
            download: 'Скачать',
            support_department: 'Поддерживающий отдел',
            technical_personnel: 'Технический персонал',
            contact_information: 'Контактная информация',
            field_support_information: 'Информация о поддержке на месте',
            remarks: 'Примечания',
            apply: 'Подать заявку',
            application_information: 'Информация о заявке',
            field_support_personnel: 'Персонал поддержки на месте',
            approval_record: 'История одобрений',
            submit_an_application: 'Подать заявку',
            refuse: 'Отказать',
            agree: 'Согласовать',
            apply_for: 'Подать заявку на',
            field_support: 'Поддержка на месте',
            reason_for_rejection: 'Причина отказа',
        },
        dialog: {
            on_site_application_details: 'Детали заявки на месте',
            on_site_application: 'Заявка на место',
            reason_for_rejection: 'Причина отказа',
            field_support_application: 'Подать заявку на техническую поддержку на месте',
            technical_personnel: 'Технический персонал',
            contact_information: 'Телефон для связи',
            field_support_time: 'Время поддержки на месте',
            note_information: 'Примечание',
        },
    },
    // 沙特阿拉伯
    arSA: {
        newly_built: 'جديد الإنشاء',
        fieldSupportNumber: 'رقم طلب الدعم الميداني',
        informationSlipNumber: 'رقم نموذج الاستفسار',
        approvalStatus: 'حالة الموافقة',
        state: 'الحالة',
        selectApplicationDate: 'اختر تاريخ الطلب',
        toBeProcessed: 'قيد الانتظار',
        processed: 'تمت المعالجة',
        initiated: 'تم البدء',
        applicationDepartment: 'قسم الطلب',
        applicant: 'المتقدم',
        reasonApplication: 'سبب الطلب',
        applicationTime: 'وقت الطلب',
        view: {
            application_department: 'قسم الطلب',
            application_person: 'المتقدم',
            responsible_person: 'المسؤول',
            associated_enquiry_number: 'رقم الاستفسار المرتبط',
            reason_application: 'سبب الطلب',
            description: 'الوصف (نموذج توقيع داخلي)',
            file_name: 'اسم الملف',
            size: 'الحجم (ميجابايت)',
            uploader: 'المحمل',
            upload_time: 'وقت الرفع',
            view: 'عرض',
            download: 'تنزيل',
            support_department: 'قسم الدعم',
            technical_personnel: 'الفنيون',
            contact_information: 'معلومات الاتصال',
            field_support_information: 'معلومات الدعم الميداني',
            remarks: 'ملاحظات',
            apply: 'موافقة',
            application_information: 'معلومات الطلب',
            field_support_personnel: 'موظفو الدعم الميداني',
            approval_record: 'سجل الموافقة',
            submit_an_application: 'تقديم طلب',
            refuse: 'رفض',
            agree: 'موافقة',
            apply_for: 'طلب',
            field_support: 'دعم ميداني',
            reason_for_rejection: 'سبب الرفض',
        },
        dialog: {
            on_site_application_details: 'تفاصيل طلب الموقع',
            on_site_application: 'طلب موقع',
            reason_for_rejection: 'سبب الرفض',
            field_support_application: 'طلب دعم ميداني',
            technical_personnel: 'الفنيون',
            contact_information: 'معلومات الاتصال',
            field_support_time: 'وقت الدعم الميداني',
            note_information: 'معلومات الملاحظات',
        },
    },
    // 保加利亚
    bgBG: {
        newly_built: 'Ново създадено',
        fieldSupportNumber: 'Номер на заявката за поддръжка на място',
        informationSlipNumber: 'Номер на заявката за информация',
        approvalStatus: 'Статус на одобрение',
        state: 'Състояние',
        selectApplicationDate: 'Изберете дата на заявката',
        toBeProcessed: 'За обработка',
        processed: 'Обработено',
        initiated: 'Инициирано',
        applicationDepartment: 'Отдел – подател на заявката',
        applicant: 'Подател на заявката',
        reasonApplication: 'Причина за заявката',
        applicationTime: 'Време на заявката',
        view: {
            application_department: 'Отдел – подател на заявката',
            application_person: 'Подател на заявката',
            responsible_person: 'Отговорно лице',
            associated_enquiry_number: 'Свързан номер на заявката',
            reason_application: 'Причина за заявката',
            description: 'Описание (вътрешен формуляр за подпис)',
            file_name: 'Име на файла',
            size: 'Размер (MB)',
            uploader: 'Качил',
            upload_time: 'Време на качване',
            view: 'Преглед',
            download: 'Изтегляне',
            support_department: 'Отдел поддръжка',
            technical_personnel: 'Технически персонал',
            contact_information: 'Контактна информация',
            field_support_information: 'Информация за поддръжка на място',
            remarks: 'Бележки',
            apply: 'Одобряване',
            application_information: 'Информация за заявката',
            field_support_personnel: 'Персонал за поддръжка на място',
            approval_record: 'Запис за одобрение',
            submit_an_application: 'Подаване на заявка',
            refuse: 'Отказ',
            agree: 'Съгласие',
            apply_for: 'Заявка',
            field_support: 'Поддръжка на място',
            reason_for_rejection: 'Причина за отказ',
        },
        dialog: {
            on_site_application_details: 'Детайли на заявката на място',
            on_site_application: 'Заявка на място',
            reason_for_rejection: 'Причина за отказ',
            field_support_application: 'Заявка за поддръжка на място',
            technical_personnel: 'Технически персонал',
            contact_information: 'Контактна информация',
            field_support_time: 'Време за поддръжка на място',
            note_information: 'Информация за бележките',
        },
    },
    // 丹麦语
    daDK: {
        newly_built: 'Nyt oprettet',
        fieldSupportNumber: 'Nummer på feltstøtteanmodning',
        informationSlipNumber: 'Forespørgselsnummer',
        approvalStatus: 'Godkendelsesstatus',
        state: 'Status',
        selectApplicationDate: 'Vælg ansøgningsdato',
        toBeProcessed: 'Afventer behandling',
        processed: 'Behandlet',
        initiated: 'Igangsat',
        applicationDepartment: 'Ansøgningsafdeling',
        applicant: 'Ansøger',
        reasonApplication: 'Årsag til ansøgning',
        applicationTime: 'Ansøgningstidspunkt',
        view: {
            application_department: 'Ansøgningsafdeling',
            application_person: 'Ansøger',
            responsible_person: 'Ansvarlig',
            associated_enquiry_number: 'Relateret forespørgselsnummer',
            reason_application: 'Årsag til ansøgning',
            description: 'Beskrivelse (intern ansøgningsskema med underskrift)',
            file_name: 'Filnavn',
            size: 'Størrelse (MB)',
            uploader: 'Uploader',
            upload_time: 'Uploadtidspunkt',
            view: 'Vis',
            download: 'Download',
            support_department: 'Supportafdeling',
            technical_personnel: 'Teknisk personale',
            contact_information: 'Kontaktinformation',
            field_support_information: 'Information om feltstøtte',
            remarks: 'Bemærkninger',
            apply: 'Godkend',
            application_information: 'Ansøgningsoplysninger',
            field_support_personnel: 'Feltstøttepersonale',
            approval_record: 'Godkendelseslog',
            submit_an_application: 'Indsend ansøgning',
            refuse: 'Afvis',
            agree: 'Accepter',
            apply_for: 'Ansøg om',
            field_support: 'Feltstøtte',
            reason_for_rejection: 'Afvisningsårsag',
        },
        dialog: {
            on_site_application_details: 'Detaljer for stedansøgning',
            on_site_application: 'Stedansøgning',
            reason_for_rejection: 'Afvisningsårsag',
            field_support_application: 'Anmodning om feltstøtte',
            technical_personnel: 'Teknisk personale',
            contact_information: 'Kontaktinformation',
            field_support_time: 'Tidspunkt for feltstøtte',
            note_information: 'Bemærkningsoplysninger',
        },
    },
    // 芬兰语
    fiFI: {
        newly_built: 'Uusi luonti',
        fieldSupportNumber: 'Kenttätuen pyyntönumero',
        informationSlipNumber: 'Tietopyyntönumero',
        approvalStatus: 'Hyväksyntätila',
        state: 'Tila',
        selectApplicationDate: 'Valitse hakupäivä',
        toBeProcessed: 'Odottaa käsittelyä',
        processed: 'Käsitelty',
        initiated: 'Aloitettu',
        applicationDepartment: 'Hakijaosasto',
        applicant: 'Hakija',
        reasonApplication: 'Hakemuksen syy',
        applicationTime: 'Hakuaika',
        view: {
            application_department: 'Hakijaosasto',
            application_person: 'Hakija',
            responsible_person: 'Vastuuhenkilö',
            associated_enquiry_number: 'Liittyvä tiedustelunumero',
            reason_application: 'Hakemuksen syy',
            description: 'Kuvaus (sisäinen allekirjoituslomake)',
            file_name: 'Tiedostonimi',
            size: 'Koko (Mt)',
            uploader: 'Lataaja',
            upload_time: 'Latausaika',
            view: 'Näytä',
            download: 'Lataa',
            support_department: 'Tukiosasto',
            technical_personnel: 'Tekniset henkilöt',
            contact_information: 'Yhteystiedot',
            field_support_information: 'Kenttätuetiedot',
            remarks: 'Huomautukset',
            apply: 'Hyväksy',
            application_information: 'Hakemustiedot',
            field_support_personnel: 'Kenttätukihenkilöstö',
            approval_record: 'Hyväksyntähistoria',
            submit_an_application: 'Lähetä hakemus',
            refuse: 'Hylkää',
            agree: 'Hyväksy',
            apply_for: 'Hae',
            field_support: 'Kenttätuki',
            reason_for_rejection: 'Hylkäämisen syy',
        },
        dialog: {
            on_site_application_details: 'Paikan päällä olevan hakemuksen tiedot',
            on_site_application: 'Paikan päällä oleva hakemus',
            reason_for_rejection: 'Hylkäämisen syy',
            field_support_application: 'Kenttätukipyyntö',
            technical_personnel: 'Tekniset henkilöt',
            contact_information: 'Yhteystiedot',
            field_support_time: 'Kenttätuen aika',
            note_information: 'Huomautustiedot',
        },
    },
    // 繁体中文台湾
    zhTW: {
        newly_built: '新建',
        fieldSupportNumber: '現場支援單號',
        informationSlipNumber: '詢問單號',
        approvalStatus: '審批狀態',
        state: '狀態',
        selectApplicationDate: '選擇申請日期',
        toBeProcessed: '待處理',
        processed: '已處理',
        initiated: '已發起',
        applicationDepartment: '申請部門',
        applicant: '申請人',
        reasonApplication: '申請原因',
        applicationTime: '申請時間',
        view: {
            application_department: '申請部門',
            application_person: '申請人',
            responsible_person: '負責人',
            associated_enquiry_number: '關聯詢問單號',
            reason_application: '申請原因',
            description: '說明（內部申請簽字單）',
            file_name: '檔案名稱',
            size: '大小(MB)',
            uploader: '上傳人',
            upload_time: '上傳時間',
            view: '查看',
            download: '下載',
            support_department: '支援部門',
            technical_personnel: '技術人員',
            contact_information: '聯絡方式',
            field_support_information: '現場支援資訊',
            remarks: '備註',
            apply: '審批',
            application_information: '申請資訊',
            field_support_personnel: '現場支援人員',
            approval_record: '審批記錄',
            submit_an_application: '提交申請',
            refuse: '拒絕',
            agree: '同意',
            apply_for: '申請',
            field_support: '現場支援',
            reason_for_rejection: '拒絕原因',
        },
        dialog: {
            on_site_application_details: '現場申請詳情',
            on_site_application: '現場申請',
            reason_for_rejection: '拒絕原因',
            field_support_application: '現場支援申請',
            technical_personnel: '技術人員',
            contact_information: '聯絡方式',
            field_support_time: '現場支援時間',
            note_information: '備註資訊',
        },
    },
    // 克罗地亚
    hrHR: {
        newly_built: 'Novo izgrađeno',
        fieldSupportNumber: 'Broj zahtjeva za podršku na terenu',
        informationSlipNumber: 'Broj upitnika',
        approvalStatus: 'Status odobrenja',
        state: 'Stanje',
        selectApplicationDate: 'Odaberite datum prijave',
        toBeProcessed: 'Na čekanju',
        processed: 'Obrađeno',
        initiated: 'Pokrenuto',
        applicationDepartment: 'Odjel podnositelja zahtjeva',
        applicant: 'Podnositelj zahtjeva',
        reasonApplication: 'Razlog zahtjeva',
        applicationTime: 'Vrijeme podnošenja zahtjeva',
        view: {
            application_department: 'Odjel podnositelja zahtjeva',
            application_person: 'Podnositelj zahtjeva',
            responsible_person: 'Odgovorna osoba',
            associated_enquiry_number: 'Povezani broj upita',
            reason_application: 'Razlog zahtjeva',
            description: 'Opis (unutarnji obrazac za potpis)',
            file_name: 'Naziv datoteke',
            size: 'Veličina (MB)',
            uploader: 'Prenositelj',
            upload_time: 'Vrijeme prijenosa',
            view: 'Pregled',
            download: 'Preuzimanje',
            support_department: 'Odjel za podršku',
            technical_personnel: 'Tehničko osoblje',
            contact_information: 'Kontakt informacije',
            field_support_information: 'Informacije o podršci na terenu',
            remarks: 'Napomene',
            apply: 'Odobri',
            application_information: 'Informacije o zahtjevu',
            field_support_personnel: 'Osoblje za podršku na terenu',
            approval_record: 'Zapisnik o odobrenju',
            submit_an_application: 'Podnesi zahtjev',
            refuse: 'Odbij',
            agree: 'Prihvati',
            apply_for: 'Zatraži',
            field_support: 'Podrška na terenu',
            reason_for_rejection: 'Razlog odbijanja',
        },
        dialog: {
            on_site_application_details: 'Detalji zahtjeva na licu mjesta',
            on_site_application: 'Zahtjev na licu mjesta',
            reason_for_rejection: 'Razlog odbijanja',
            field_support_application: 'Zahtjev za podršku na terenu',
            technical_personnel: 'Tehničko osoblje',
            contact_information: 'Kontakt informacije',
            field_support_time: 'Vrijeme podrške na terenu',
            note_information: 'Informacije o napomenama',
        },
    },
    // 拉脱维亚
    lvLV: {
        newly_built: 'Jaunizveidots',
        fieldSupportNumber: 'Lauka atbalsta pieteikuma numurs',
        informationSlipNumber: 'Informācijas pieprasījuma numurs',
        approvalStatus: 'Apstiprinājuma statuss',
        state: 'Statuss',
        selectApplicationDate: 'Izvēlieties pieteikuma datumu',
        toBeProcessed: 'Gaida apstrādi',
        processed: 'Apstrādāts',
        initiated: 'Sākts',
        applicationDepartment: 'Pieteikuma nodaļa',
        applicant: 'Pieteicējs',
        reasonApplication: 'Pieteikuma iemesls',
        applicationTime: 'Pieteikuma laiks',
        view: {
            application_department: 'Pieteikuma nodaļa',
            application_person: 'Pieteicējs',
            responsible_person: 'Atbildīgā persona',
            associated_enquiry_number: 'Saistītais vaicājuma numurs',
            reason_application: 'Pieteikuma iemesls',
            description: 'Apraksts (iekšējais pieteikuma paraksta veidlapa)',
            file_name: 'Faila nosaukums',
            size: 'Izmērs (MB)',
            uploader: 'Augšupielādētājs',
            upload_time: 'Augšupielādes laiks',
            view: 'Skatīt',
            download: 'Lejupielādēt',
            support_department: 'Atbalsta nodaļa',
            technical_personnel: 'Tehniskais personāls',
            contact_information: 'Kontaktinformācija',
            field_support_information: 'Lauka atbalsta informācija',
            remarks: 'Piezīmes',
            apply: 'Apstiprināt',
            application_information: 'Pieteikuma informācija',
            field_support_personnel: 'Lauka atbalsta personāls',
            approval_record: 'Apstiprinājuma ieraksts',
            submit_an_application: 'Iesniegt pieteikumu',
            refuse: 'Noraidīt',
            agree: 'Piekrīt',
            apply_for: 'Pieteikties',
            field_support: 'Lauka atbalsts',
            reason_for_rejection: 'Noraidījuma iemesls',
        },
        dialog: {
            on_site_application_details: 'Vietējā pieteikuma informācija',
            on_site_application: 'Vietējais pieteikums',
            reason_for_rejection: 'Noraidījuma iemesls',
            field_support_application: 'Lauka atbalsta pieteikums',
            technical_personnel: 'Tehniskais personāls',
            contact_information: 'Kontaktinformācija',
            field_support_time: 'Lauka atbalsta laiks',
            note_information: 'Piezīmju informācija',
        },
    },
    // 立陶宛
    ltLT: {
        newly_built: 'Naujai sukurtas',
        fieldSupportNumber: 'Vietinės paramos užklausos numeris',
        informationSlipNumber: 'Užklausos numeris',
        approvalStatus: 'Patvirtinimo būsena',
        state: 'Būsena',
        selectApplicationDate: 'Pasirinkite paraiškos datą',
        toBeProcessed: 'Laukiama apdorojimo',
        processed: 'Apdorota',
        initiated: 'Inicijuota',
        applicationDepartment: 'Paraiškos skyrius',
        applicant: 'Paraiškos teikėjas',
        reasonApplication: 'Paraiškos pateikimo priežastis',
        applicationTime: 'Paraiškos laikas',
        view: {
            application_department: 'Paraiškos skyrius',
            application_person: 'Paraiškos teikėjas',
            responsible_person: 'Atsakingas asmuo',
            associated_enquiry_number: 'Susijęs užklausos numeris',
            reason_application: 'Paraiškos pateikimo priežastis',
            description: 'Aprašymas (vidinė paraiškos pasirašymo forma)',
            file_name: 'Failo pavadinimas',
            size: 'Dydis (MB)',
            uploader: 'Įkėlėjas',
            upload_time: 'Įkėlimo laikas',
            view: 'Peržiūrėti',
            download: 'Atsisiųsti',
            support_department: 'Paramos skyrius',
            technical_personnel: 'Techninis personalas',
            contact_information: 'Kontaktinė informacija',
            field_support_information: 'Vietinės paramos informacija',
            remarks: 'Pastabos',
            apply: 'Patvirtinti',
            application_information: 'Paraiškos informacija',
            field_support_personnel: 'Vietinės paramos personalas',
            approval_record: 'Patvirtinimo įrašas',
            submit_an_application: 'Pateikti paraišką',
            refuse: 'Atmesti',
            agree: 'Sutikti',
            apply_for: 'Prašyti',
            field_support: 'Vietinė parama',
            reason_for_rejection: 'Atmetimo priežastis',
        },
        dialog: {
            on_site_application_details: 'Vietinės paraiškos informacija',
            on_site_application: 'Vietinė paraiška',
            reason_for_rejection: 'Atmetimo priežastis',
            field_support_application: 'Vietinės paramos paraiška',
            technical_personnel: 'Techninis personalas',
            contact_information: 'Kontaktinė informacija',
            field_support_time: 'Vietinės paramos laikas',
            note_information: 'Pastabų informacija',
        },
    },
    // 罗马尼亚
    roRO: {
        newly_built: 'Nou creat',
        fieldSupportNumber: 'Număr solicitare suport pe teren',
        informationSlipNumber: 'Număr cerere informații',
        approvalStatus: 'Stare aprobare',
        state: 'Stare',
        selectApplicationDate: 'Selectați data solicitării',
        toBeProcessed: 'În așteptare',
        processed: 'Procesat',
        initiated: 'Inițiat',
        applicationDepartment: 'Departament solicitant',
        applicant: 'Solicitant',
        reasonApplication: 'Motivul solicitării',
        applicationTime: 'Timpul solicitării',
        view: {
            application_department: 'Departament solicitant',
            application_person: 'Solicitant',
            responsible_person: 'Persoană responsabilă',
            associated_enquiry_number: 'Număr cerere asociată',
            reason_application: 'Motivul solicitării',
            description: 'Descriere (formular intern de semnătură)',
            file_name: 'Nume fișier',
            size: 'Dimensiune (MB)',
            uploader: 'Încărcător',
            upload_time: 'Timp încărcare',
            view: 'Vizualizare',
            download: 'Descărcare',
            support_department: 'Departament suport',
            technical_personnel: 'Personal tehnic',
            contact_information: 'Informații de contact',
            field_support_information: 'Informații suport pe teren',
            remarks: 'Observații',
            apply: 'Aprobă',
            application_information: 'Informații solicitare',
            field_support_personnel: 'Personal suport pe teren',
            approval_record: 'Istoric aprobări',
            submit_an_application: 'Trimite solicitarea',
            refuse: 'Respinge',
            agree: 'De acord',
            apply_for: 'Solicită',
            field_support: 'Suport pe teren',
            reason_for_rejection: 'Motiv respingere',
        },
        dialog: {
            on_site_application_details: 'Detalii solicitare pe teren',
            on_site_application: 'Solicitare pe teren',
            reason_for_rejection: 'Motiv respingere',
            field_support_application: 'Solicitare suport pe teren',
            technical_personnel: 'Personal tehnic',
            contact_information: 'Informații de contact',
            field_support_time: 'Timp suport pe teren',
            note_information: 'Informații observații',
        },
    },
    // 挪威博克马尔
    nbNO: {
        newly_built: 'Nylig opprettet',
        fieldSupportNumber: 'Feltsupportforespørselsnummer',
        informationSlipNumber: 'Spørrenummer',
        approvalStatus: 'Godkjenningsstatus',
        state: 'Status',
        selectApplicationDate: 'Velg søknadsdato',
        toBeProcessed: 'Venter på behandling',
        processed: 'Behandlet',
        initiated: 'Startet',
        applicationDepartment: 'Søknadsavdeling',
        applicant: 'Søker',
        reasonApplication: 'Årsak til søknad',
        applicationTime: 'Søknadstidspunkt',
        view: {
            application_department: 'Søknadsavdeling',
            application_person: 'Søker',
            responsible_person: 'Ansvarlig',
            associated_enquiry_number: 'Tilknyttet spørrenummer',
            reason_application: 'Årsak til søknad',
            description: 'Beskrivelse (intern søknadsskjema med signatur)',
            file_name: 'Filnavn',
            size: 'Størrelse (MB)',
            uploader: 'Opplaster',
            upload_time: 'Opplastingstidspunkt',
            view: 'Vis',
            download: 'Last ned',
            support_department: 'Støtteavdeling',
            technical_personnel: 'Teknisk personell',
            contact_information: 'Kontaktinformasjon',
            field_support_information: 'Informasjon om feltsupport',
            remarks: 'Merknader',
            apply: 'Godkjenn',
            application_information: 'Søknadsinformasjon',
            field_support_personnel: 'Feltsupportpersonell',
            approval_record: 'Godkjenningslogg',
            submit_an_application: 'Send inn søknad',
            refuse: 'Avslå',
            agree: 'Godta',
            apply_for: 'Søk om',
            field_support: 'Feltsupport',
            reason_for_rejection: 'Avslåingsårsak',
        },
        dialog: {
            on_site_application_details: 'Detaljer for stedsbasert søknad',
            on_site_application: 'Stedsbasert søknad',
            reason_for_rejection: 'Avslåingsårsak',
            field_support_application: 'Feltsupportsøknad',
            technical_personnel: 'Teknisk personell',
            contact_information: 'Kontaktinformasjon',
            field_support_time: 'Tidspunkt for feltsupport',
            note_information: 'Notatinformasjon',
        },
    },
    // 葡萄牙语巴西
    ptBX: {
        newly_built: 'Recém-criado',
        fieldSupportNumber: 'Número do pedido de suporte em campo',
        informationSlipNumber: 'Número do formulário de consulta',
        approvalStatus: 'Status de aprovação',
        state: 'Estado',
        selectApplicationDate: 'Selecione a data da solicitação',
        toBeProcessed: 'Aguardando processamento',
        processed: 'Processado',
        initiated: 'Iniciado',
        applicationDepartment: 'Departamento solicitante',
        applicant: 'Solicitante',
        reasonApplication: 'Motivo da solicitação',
        applicationTime: 'Horário da solicitação',
        view: {
            application_department: 'Departamento solicitante',
            application_person: 'Solicitante',
            responsible_person: 'Responsável',
            associated_enquiry_number: 'Número de consulta associado',
            reason_application: 'Motivo da solicitação',
            description: 'Descrição (formulário interno com assinatura)',
            file_name: 'Nome do arquivo',
            size: 'Tamanho (MB)',
            uploader: 'Carregador',
            upload_time: 'Data de envio',
            view: 'Visualizar',
            download: 'Baixar',
            support_department: 'Departamento de suporte',
            technical_personnel: 'Pessoal técnico',
            contact_information: 'Informações de contato',
            field_support_information: 'Informações de suporte em campo',
            remarks: 'Observações',
            apply: 'Aprovar',
            application_information: 'Informações da solicitação',
            field_support_personnel: 'Equipe de suporte em campo',
            approval_record: 'Registro de aprovação',
            submit_an_application: 'Enviar solicitação',
            refuse: 'Recusar',
            agree: 'Concordar',
            apply_for: 'Solicitar',
            field_support: 'Suporte em campo',
            reason_for_rejection: 'Motivo da recusa',
        },
        dialog: {
            on_site_application_details: 'Detalhes da solicitação no local',
            on_site_application: 'Solicitação no local',
            reason_for_rejection: 'Motivo da recusa',
            field_support_application: 'Solicitação de suporte em campo',
            technical_personnel: 'Pessoal técnico',
            contact_information: 'Informações de contato',
            field_support_time: 'Horário do suporte em campo',
            note_information: 'Informações das observações',
        },
    },
    // 瑞典语
    svSE: {
        newly_built: 'Nyskapad',
        fieldSupportNumber: 'Fältsupportförfrågnansnummer',
        informationSlipNumber: 'Förfrågningsnummer',
        approvalStatus: 'Godkännandestatus',
        state: 'Status',
        selectApplicationDate: 'Välj ansökningsdatum',
        toBeProcessed: 'Väntar på behandling',
        processed: 'Behandlad',
        initiated: 'Initierad',
        applicationDepartment: 'Ansökningsavdelning',
        applicant: 'Ansökande',
        reasonApplication: 'Anledning till ansökan',
        applicationTime: 'Ansökningstidpunkt',
        view: {
            application_department: 'Ansökningsavdelning',
            application_person: 'Ansökande',
            responsible_person: 'Ansvarig',
            associated_enquiry_number: 'Relaterat förfrågningsnummer',
            reason_application: 'Anledning till ansökan',
            description: 'Beskrivning (internt ansökningsformulär med signatur)',
            file_name: 'Filnamn',
            size: 'Storlek (MB)',
            uploader: 'Uppladdare',
            upload_time: 'Uppladdningstid',
            view: 'Visa',
            download: 'Ladda ner',
            support_department: 'Supportavdelning',
            technical_personnel: 'Teknisk personal',
            contact_information: 'Kontaktinformation',
            field_support_information: 'Information om fältsupport',
            remarks: 'Anmärkningar',
            apply: 'Godkänn',
            application_information: 'Ansökningsinformation',
            field_support_personnel: 'Fältsupportpersonal',
            approval_record: 'Godkännandehistorik',
            submit_an_application: 'Skicka in ansökan',
            refuse: 'Avvisa',
            agree: 'Godkänn',
            apply_for: 'Ansök om',
            field_support: 'Fältsupport',
            reason_for_rejection: 'Avvisningsorsak',
        },
        dialog: {
            on_site_application_details: 'Detaljer för platsansökan',
            on_site_application: 'Platsansökan',
            reason_for_rejection: 'Avvisningsorsak',
            field_support_application: 'Ansökan om fältsupport',
            technical_personnel: 'Teknisk personal',
            contact_information: 'Kontaktinformation',
            field_support_time: 'Tid för fältsupport',
            note_information: 'Anteckningsinformation',
        },
    },
    // 斯洛伐克
    skSK: {
        newly_built: 'Novo vytvorené',
        fieldSupportNumber: 'Číslo požiadavky na podporu na mieste',
        informationSlipNumber: 'Číslo informačného lístka',
        approvalStatus: 'Stav schválenia',
        state: 'Stav',
        selectApplicationDate: 'Vyberte dátum žiadosti',
        toBeProcessed: 'Čaká na spracovanie',
        processed: 'Spracované',
        initiated: 'Zahájené',
        applicationDepartment: 'Oddelenie žiadateľa',
        applicant: 'Žiadateľ',
        reasonApplication: 'Dôvod žiadosti',
        applicationTime: 'Čas podania žiadosti',
        view: {
            application_department: 'Oddelenie žiadateľa',
            application_person: 'Žiadateľ',
            responsible_person: 'Zodpovedná osoba',
            associated_enquiry_number: 'Priradené číslo dopytu',
            reason_application: 'Dôvod žiadosti',
            description: 'Popis (vnútorný formulár na podpis)',
            file_name: 'Názov súboru',
            size: 'Veľkosť (MB)',
            uploader: 'Nahral',
            upload_time: 'Čas nahratia',
            view: 'Zobraziť',
            download: 'Stiahnuť',
            support_department: 'Oddelenie podpory',
            technical_personnel: 'Technický personál',
            contact_information: 'Kontaktné údaje',
            field_support_information: 'Informácie o podpore na mieste',
            remarks: 'Poznámky',
            apply: 'Schváliť',
            application_information: 'Informácie o žiadosti',
            field_support_personnel: 'Personál podpory na mieste',
            approval_record: 'Záznam o schválení',
            submit_an_application: 'Odoslať žiadosť',
            refuse: 'Odmietnuť',
            agree: 'Súhlasiť',
            apply_for: 'Žiadať',
            field_support: 'Podpora na mieste',
            reason_for_rejection: 'Dôvod zamietnutia',
        },
        dialog: {
            on_site_application_details: 'Podrobnosti žiadosti na mieste',
            on_site_application: 'Žiadosť na mieste',
            reason_for_rejection: 'Dôvod zamietnutia',
            field_support_application: 'Žiadosť o podporu na mieste',
            technical_personnel: 'Technický personál',
            contact_information: 'Kontaktné údaje',
            field_support_time: 'Čas podpory na mieste',
            note_information: 'Informácie o poznámkach',
        },
    },
    // 斯洛文尼亚
    slSI: {
        newly_built: 'Novo ustvarjeno',
        fieldSupportNumber: 'Številka zahteve za podporo na terenu',
        informationSlipNumber: 'Številka vprašalnika',
        approvalStatus: 'Status odobritve',
        state: 'Stanje',
        selectApplicationDate: 'Izberite datum vloge',
        toBeProcessed: 'Na čakanju',
        processed: 'Obdelano',
        initiated: 'Začeto',
        applicationDepartment: 'Oddelj vlagatelja',
        applicant: 'Vlagatelj',
        reasonApplication: 'Razlog za vlogo',
        applicationTime: 'Čas vloge',
        view: {
            application_department: 'Oddelj vlagatelja',
            application_person: 'Vlagatelj',
            responsible_person: 'Odgovorna oseba',
            associated_enquiry_number: 'Povezana številka poizvedbe',
            reason_application: 'Razlog za vlogo',
            description: 'Opis (notranji obrazec za podpis)',
            file_name: 'Ime datoteke',
            size: 'Velikost (MB)',
            uploader: 'Naložil',
            upload_time: 'Čas nalaganja',
            view: 'Poglej',
            download: 'Prenesi',
            support_department: 'Oddelj za podporo',
            technical_personnel: 'Tehnično osebje',
            contact_information: 'Kontaktni podatki',
            field_support_information: 'Informacije o podpori na terenu',
            remarks: 'Opombe',
            apply: 'Odobri',
            application_information: 'Informacije o vlogi',
            field_support_personnel: 'Osebje za podporo na terenu',
            approval_record: 'Zapis odobritve',
            submit_an_application: 'Pošlji vlogo',
            refuse: 'Zavrni',
            agree: 'Strinjam se',
            apply_for: 'Vloži',
            field_support: 'Podpora na terenu',
            reason_for_rejection: 'Razlog za zavrnitev',
        },
        dialog: {
            on_site_application_details: 'Podrobnosti vloge na kraju samem',
            on_site_application: 'Vloga na kraju samem',
            reason_for_rejection: 'Razlog za zavrnitev',
            field_support_application: 'Zahteva za podporo na terenu',
            technical_personnel: 'Tehnično osebje',
            contact_information: 'Kontaktni podatki',
            field_support_time: 'Čas podpore na terenu',
            note_information: 'Informacije o opombah',
        },
    },
    // 泰语
    thTH: {
        newly_built: 'สร้างใหม่',
        fieldSupportNumber: 'หมายเลขคำขอสนับสนุนภาคสนาม',
        informationSlipNumber: 'หมายเลขแบบสอบถาม',
        approvalStatus: 'สถานะการอนุมัติ',
        state: 'สถานะ',
        selectApplicationDate: 'เลือกวันที่ยื่นคำขอ',
        toBeProcessed: 'รอการดำเนินการ',
        processed: 'ดำเนินการแล้ว',
        initiated: 'เริ่มต้นแล้ว',
        applicationDepartment: 'แผนกผู้ยื่นคำขอ',
        applicant: 'ผู้ยื่นคำขอ',
        reasonApplication: 'เหตุผลในการยื่นคำขอ',
        applicationTime: 'เวลาที่ยื่นคำขอ',
        view: {
            application_department: 'แผนกผู้ยื่นคำขอ',
            application_person: 'ผู้ยื่นคำขอ',
            responsible_person: 'ผู้รับผิดชอบ',
            associated_enquiry_number: 'หมายเลขคำถามที่เกี่ยวข้อง',
            reason_application: 'เหตุผลในการยื่นคำขอ',
            description: 'คำอธิบาย (แบบฟอร์มภายในสำหรับลงนาม)',
            file_name: 'ชื่อไฟล์',
            size: 'ขนาด (MB)',
            uploader: 'ผู้อัปโหลด',
            upload_time: 'เวลาอัปโหลด',
            view: 'ดู',
            download: 'ดาวน์โหลด',
            support_department: 'แผนกสนับสนุน',
            technical_personnel: 'บุคลากรเทคนิค',
            contact_information: 'ข้อมูลติดต่อ',
            field_support_information: 'ข้อมูลการสนับสนุนภาคสนาม',
            remarks: 'หมายเหตุ',
            apply: 'อนุมัติ',
            application_information: 'ข้อมูลคำขอ',
            field_support_personnel: 'บุคลากรสนับสนุนภาคสนาม',
            approval_record: 'บันทึกการอนุมัติ',
            submit_an_application: 'ส่งคำขอ',
            refuse: 'ปฏิเสธ',
            agree: 'ยอมรับ',
            apply_for: 'ยื่นคำขอ',
            field_support: 'การสนับสนุนภาคสนาม',
            reason_for_rejection: 'เหตุผลในการปฏิเสธ',
        },
        dialog: {
            on_site_application_details: 'รายละเอียดคำขอภาคสนาม',
            on_site_application: 'คำขอภาคสนาม',
            reason_for_rejection: 'เหตุผลในการปฏิเสธ',
            field_support_application: 'คำขอสนับสนุนภาคสนาม',
            technical_personnel: 'บุคลากรเทคนิค',
            contact_information: 'ข้อมูลติดต่อ',
            field_support_time: 'เวลาสนับสนุนภาคสนาม',
            note_information: 'ข้อมูลหมายเหตุ',
        },
    },
    // 乌克兰语
    ukUA: {
        newly_built: 'Нове створення',
        fieldSupportNumber: 'Номер заявки на польову підтримку',
        informationSlipNumber: 'Номер запиту',
        approvalStatus: 'Статус затвердження',
        state: 'Стан',
        selectApplicationDate: 'Виберіть дату подання заявки',
        toBeProcessed: 'Очікує обробки',
        processed: 'Оброблено',
        initiated: 'Ініційовано',
        applicationDepartment: 'Відділ-заявник',
        applicant: 'Заявник',
        reasonApplication: 'Причина заявки',
        applicationTime: 'Час подання заявки',
        view: {
            application_department: 'Відділ-заявник',
            application_person: 'Заявник',
            responsible_person: 'Відповідальна особа',
            associated_enquiry_number: 'Пов’язаний номер запиту',
            reason_application: 'Причина заявки',
            description: 'Опис (внутрішній бланк для підпису)',
            file_name: 'Назва файлу',
            size: 'Розмір (МБ)',
            uploader: 'Завантажив',
            upload_time: 'Час завантаження',
            view: 'Переглянути',
            download: 'Завантажити',
            support_department: 'Відділ підтримки',
            technical_personnel: 'Технічний персонал',
            contact_information: 'Контактна інформація',
            field_support_information: 'Інформація про польову підтримку',
            remarks: 'Примітки',
            apply: 'Затвердити',
            application_information: 'Інформація про заявку',
            field_support_personnel: 'Персонал польової підтримки',
            approval_record: 'Журнал затверджень',
            submit_an_application: 'Подати заявку',
            refuse: 'Відхилити',
            agree: 'Погодитись',
            apply_for: 'Подати заявку на',
            field_support: 'Польова підтримка',
            reason_for_rejection: 'Причина відмови',
        },
        dialog: {
            on_site_application_details: 'Деталі заявки на місці',
            on_site_application: 'Заявка на місці',
            reason_for_rejection: 'Причина відмови',
            field_support_application: 'Заявка на польову підтримку',
            technical_personnel: 'Технічний персонал',
            contact_information: 'Контактна інформація',
            field_support_time: 'Час польової підтримки',
            note_information: 'Інформація про примітки',
        },
    },
    // 希腊语
    elGR: {
        newly_built: 'Νέα δημιουργία',
        fieldSupportNumber: 'Αριθμός αίτησης υποστήριξης επιτόπου',
        informationSlipNumber: 'Αριθμός ερωτηματολογίου',
        approvalStatus: 'Κατάσταση έγκρισης',
        state: 'Κατάσταση',
        selectApplicationDate: 'Επιλογή ημερομηνίας αίτησης',
        toBeProcessed: 'Σε αναμονή επεξεργασίας',
        processed: 'Επεξεργάστηκε',
        initiated: 'Ξεκίνησε',
        applicationDepartment: 'Τμήμα αίτησης',
        applicant: 'Αιτών',
        reasonApplication: 'Λόγος αίτησης',
        applicationTime: 'Ώρα αίτησης',
        view: {
            application_department: 'Τμήμα αίτησης',
            application_person: 'Αιτών',
            responsible_person: 'Υπεύθυνος',
            associated_enquiry_number: 'Σχετικός αριθμός ερωτήματος',
            reason_application: 'Λόγος αίτησης',
            description: 'Περιγραφή (εσωτερικό έντυπο υπογραφής)',
            file_name: 'Όνομα αρχείου',
            size: 'Μέγεθος (MB)',
            uploader: 'Ανέβασε',
            upload_time: 'Ώρα ανέβασματος',
            view: 'Προβολή',
            download: 'Λήψη',
            support_department: 'Τμήμα υποστήριξης',
            technical_personnel: 'Τεχνικό προσωπικό',
            contact_information: 'Πληροφορίες επικοινωνίας',
            field_support_information: 'Πληροφορίες υποστήριξης επιτόπου',
            remarks: 'Σχόλια',
            apply: 'Έγκριση',
            application_information: 'Πληροφορίες αίτησης',
            field_support_personnel: 'Προσωπικό υποστήριξης επιτόπου',
            approval_record: 'Ιστορικό έγκρισης',
            submit_an_application: 'Υποβολή αίτησης',
            refuse: 'Απόρριψη',
            agree: 'Αποδοχή',
            apply_for: 'Αίτηση για',
            field_support: 'Υποστήριξη επιτόπου',
            reason_for_rejection: 'Λόγος απόρριψης',
        },
        dialog: {
            on_site_application_details: 'Λεπτομέρειες αίτησης επιτόπου',
            on_site_application: 'Αίτηση επιτόπου',
            reason_for_rejection: 'Λόγος απόρριψης',
            field_support_application: 'Αίτηση υποστήριξης επιτόπου',
            technical_personnel: 'Τεχνικό προσωπικό',
            contact_information: 'Πληροφορίες επικοινωνίας',
            field_support_time: 'Ώρα υποστήριξης επιτόπου',
            note_information: 'Πληροφορίες σημειώσεων',
        },
    },
    // 爱沙尼亚
    etEE: {
        newly_built: 'Uus loomine',
        fieldSupportNumber: 'Välitoe taotluse number',
        informationSlipNumber: 'Päringu number',
        approvalStatus: 'Heakskiidu staatus',
        state: 'Olek',
        selectApplicationDate: 'Valige taotluse kuupäev',
        toBeProcessed: 'Ootel',
        processed: 'Töödeldud',
        initiated: 'Algatatud',
        applicationDepartment: 'Taotleja osakond',
        applicant: 'Taotleja',
        reasonApplication: 'Taotluse põhjus',
        applicationTime: 'Taotluse esitamise aeg',
        view: {
            application_department: 'Taotleja osakond',
            application_person: 'Taotleja',
            responsible_person: 'Vastutaja',
            associated_enquiry_number: 'Seotud päringu number',
            reason_application: 'Taotluse põhjus',
            description: 'Kirjeldus (sisemine allkirjastamise vorm)',
            file_name: 'Faili nimi',
            size: 'Suurus (MB)',
            uploader: 'Üleslaadija',
            upload_time: 'Üleslaadimise aeg',
            view: 'Vaata',
            download: 'Laadi alla',
            support_department: 'Toe osakond',
            technical_personnel: 'Tehniline personal',
            contact_information: 'Kontaktandmed',
            field_support_information: 'Välitoe teave',
            remarks: 'Märkused',
            apply: 'Kinnita',
            application_information: 'Taotluse andmed',
            field_support_personnel: 'Välitoe personal',
            approval_record: 'Heakskiidu ajalugu',
            submit_an_application: 'Esita taotlus',
            refuse: 'Keeldu',
            agree: 'Nõustu',
            apply_for: 'Taotle',
            field_support: 'Välitugi',
            reason_for_rejection: 'Tagasilükkamise põhjus',
        },
        dialog: {
            on_site_application_details: 'Kohapealse taotluse üksikasjad',
            on_site_application: 'Kohapealne taotlus',
            reason_for_rejection: 'Tagasilükkamise põhjus',
            field_support_application: 'Välitoe taotlus',
            technical_personnel: 'Tehniline personal',
            contact_information: 'Kontaktandmed',
            field_support_time: 'Välitoe aeg',
            note_information: 'Märkuste teave',
        },
    },
    // 哈萨克
    kkKZ: {
        newly_built: 'Жаңадан құрылған',
        fieldSupportNumber: 'Өрістік қолдау өтінішінің нөмірі',
        informationSlipNumber: 'Сауалнама нөмірі',
        approvalStatus: 'Бекіту күйі',
        state: 'Күйі',
        selectApplicationDate: 'Өтініш беру күнін таңдаңыз',
        toBeProcessed: 'Өңдеуді күтуде',
        processed: 'Өңделді',
        initiated: 'Басталды',
        applicationDepartment: 'Өтініш беруші бөлім',
        applicant: 'Өтініш беруші',
        reasonApplication: 'Өтініш беру себебі',
        applicationTime: 'Өтініш беру уақыты',
        view: {
            application_department: 'Өтініш беруші бөлім',
            application_person: 'Өтініш беруші',
            responsible_person: 'Жауапты тұлға',
            associated_enquiry_number: 'Байланысты сауалнама нөмірі',
            reason_application: 'Өтініш беру себебі',
            description: 'Сипаттама (ішкі қол қою парағы)',
            file_name: 'Файл атауы',
            size: 'Өлшемі (МБ)',
            uploader: 'Жүктеген адам',
            upload_time: 'Жүктеу уақыты',
            view: 'Қарау',
            download: 'Жүктеу',
            support_department: 'Қолдау бөлімі',
            technical_personnel: 'Техникалық қызметкерлер',
            contact_information: 'Байланыс ақпараты',
            field_support_information: 'Өрістік қолдау ақпараты',
            remarks: 'Ескертпелер',
            apply: 'Бекіту',
            application_information: 'Өтініш ақпараты',
            field_support_personnel: 'Өрістік қолдау қызметкерлері',
            approval_record: 'Бекіту жазбалары',
            submit_an_application: 'Өтініш беру',
            refuse: 'Қабылдамау',
            agree: 'Келісім',
            apply_for: 'Өтініш беру',
            field_support: 'Өрістік қолдау',
            reason_for_rejection: 'Қабылдамау себебі',
        },
        dialog: {
            on_site_application_details: 'Орындағы өтініш туралы мәліметтер',
            on_site_application: 'Орындағы өтініш',
            reason_for_rejection: 'Қабылдамау себебі',
            field_support_application: 'Өрістік қолдау өтініші',
            technical_personnel: 'Техникалық қызметкерлер',
            contact_information: 'Байланыс ақпараты',
            field_support_time: 'Өрістік қолдау уақыты',
            note_information: 'Ескертпе ақпараты',
        },
    },
    // 希伯来语
    heIL: {
        newly_built: 'נוצר חדש',
        fieldSupportNumber: 'מספר בקשת תמיכה现场',
        informationSlipNumber: 'מספר פניה',
        approvalStatus: 'סטטוס אישור',
        state: 'סטטוס',
        selectApplicationDate: 'בחר תאריך בקשה',
        toBeProcessed: 'ממתין לעיבוד',
        processed: 'עובד',
        initiated: 'אותחל',
        applicationDepartment: 'מחלקת המבקש',
        applicant: 'מבקש',
        reasonApplication: 'סיבת הבקשה',
        applicationTime: 'זמן הבקשה',
        view: {
            application_department: 'מחלקת המבקש',
            application_person: 'מבקש',
            responsible_person: 'אחראי',
            associated_enquiry_number: 'מספר פנייה קשור',
            reason_application: 'סיבת הבקשה',
            description: 'תיאור (טופס פנימית לחתימה)',
            file_name: 'שם הקובץ',
            size: 'גודל (MB)',
            uploader: 'מעלה',
            upload_time: 'זמן העלאה',
            view: 'צפייה',
            download: 'הורדה',
            support_department: 'מחלקת תמיכה',
            technical_personnel: 'כادر טכני',
            contact_information: 'פרטי קשר',
            field_support_information: 'מידע על תמיכה现场',
            remarks: 'הערות',
            apply: 'אישור',
            application_information: 'מידע על הבקשה',
            field_support_personnel: 'כادر תמיכה现场',
            approval_record: 'יומן אישורים',
            submit_an_application: 'שלח בקשה',
            refuse: 'דחה',
            agree: 'אשר',
            apply_for: 'בקש',
            field_support: 'תמיכה现场',
            reason_for_rejection: 'סיבת דחייה',
        },
        dialog: {
            on_site_application_details: 'פרטי בקשת现场',
            on_site_application: 'בקשת现场',
            reason_for_rejection: 'סיבת דחייה',
            field_support_application: 'בקשת תמיכה现场',
            technical_personnel: 'כادر טכני',
            contact_information: 'פרטי קשר',
            field_support_time: 'מועד תמיכה现场',
            note_information: 'מידע על הערות',
        },
    },
};
